
import React, { useEffect, useRef, useState } from 'react';
import { Trans, withTranslation } from 'react-i18next';
import { createPIXCharge } from '../../../../../client/emp';
import { Spin, Alert, Typography } from 'antd';
import { FormatPrice } from '../../../../../util/price';
import { useInterval } from '../../../../../hooks/useInterval';

const PixContent = ({ pixData, t }) => {

    if (pixData.status === 'CONCLUIDA') {
        return (
            <div>
                <Alert message={t('payment_successfully_completed')} type="success" showIcon />
            </div>
        )
    }

    if (pixData.is_expired) {
        return (
            <div>
                <Alert message={t('pix_payment_expired')} type="error" showIcon />
            </div>
        )
    }

    return (
        <div>
            <p>
                <Trans
                    i18nKey="pix_payment_info"
                    components={[<strong key="1"></strong>]}
                    values={{ minutes: pixData.expiration / 60 }}
                />
            </p>
            <p>
                <strong>{t('total')}:&nbsp;</strong>
                <FormatPrice price={pixData.value} currency="BRL" />
            </p>
            <p><strong>QR Code:</strong></p>
            {pixData.qr_code_base64 && (
                <div>
                    <img alt="PIX QR Code" src={pixData.qr_code_base64} style={{ maxWidth: '100%', height: 'auto' }} />
                </div>
            )}
            {pixData.qr_code && (
                <div className='gx-mt-3'>
                    <p><strong>{t('code')}:</strong></p>
                    <div style={{ wordBreak: 'break-all', background: '#f4f4f4', padding: 10, borderRadius: 5 }}>
                        <Typography.Text copyable>{pixData.qr_code}</Typography.Text>
                    </div>
                </div>
            )}
        </div>
    )
}

//oltre questo tempo la richiesta è considerata persa, altrimenti il polling non riparte più.
//la più lenta vista in produzione è di 313s, stare larghi
const IN_FLIGHT_TIMEOUT_MS = 10 * 60 * 1000;

const PixCompletedInformation = ({ tickets, t }) => {

    const [pixResponse, setPixResponse] = useState({
        data: null,
        error: null,
        loading: true
    });

    //createPIXCharge crea una nuova cobrança se non ne trova una già salvata, quindi due
    //chiamate sovrapposte generano due QR diversi e solo uno resta legato al pagamento
    const inFlightSince = useRef(0);

    const createPIXChargeRequest = () => {

        const now = Date.now();

        if (inFlightSince.current && (now - inFlightSince.current) < IN_FLIGHT_TIMEOUT_MS) {
            return;
        }

        inFlightSince.current = now;

        createPIXCharge({
            input: {
                tickets_id: tickets.id,
                force_creation: false
            }
        }).then((response) => {

            inFlightSince.current = 0;

            if (response.data && response.data.data && response.data.data.createPIXCharge) {
                setPixResponse({
                    data: response.data.data.createPIXCharge,
                    error: null,
                    loading: false
                });
            } else {
                setPixResponse({
                    data: null,
                    error: 'no_data',
                    loading: false
                });
            }

        }).catch((error) => {
            inFlightSince.current = 0;
            setPixResponse({
                data: null,
                error: error.message || 'unknown_error',
                loading: false
            });
        });
    }

    useEffect(() => {
        createPIXChargeRequest();   
    }, []);

    const interval = useInterval(() => {
        if (pixResponse.data && pixResponse.data.status === 'CONCLUIDA') {
            clearInterval(interval);
        } else {
            createPIXChargeRequest();
        }
    }, 18 * 1000); //18 seconds

    return (
        <div>
            <h3 className='gx-mb-3'>{t('pay_with_pix')}</h3>
            {pixResponse.loading && <div className='gx-text-center gx-my-5 gx-w-100'><Spin size="large" /></div>}
            {!pixResponse.loading && pixResponse.error && (
                <Alert message={t('payment_generic_error')} type="error" showIcon />
            )}
            {!pixResponse.loading && pixResponse.data && <PixContent pixData={pixResponse.data} t={t} />}
        </div>
    )

}

export default withTranslation(['common'])(PixCompletedInformation);